import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import { Button } from '@mui/material';
import * as React from 'react';
import { TextFieldProps, useNotify, useRecordContext, useTranslate } from 'react-admin';
import { getToken } from '../authentication/authProvider';

export type InvoicePdfButtonProps = TextFieldProps & {
  source: string;
  locale: string;
};

const InvoicePdfButton = (props: InvoicePdfButtonProps ) => {
  const record = useRecordContext();
  const translate = useTranslate();
  const notify = useNotify();
  const getInvoicePdf = async (Id: string) => {
    try {
      const result = await fetch(
        `${process.env.REACT_APP_PAPERMAN_API_URL}quickbooks/invoices/${props.locale}/print/${Id}`,
        {
          method: 'GET',
          headers: {
            Accept: 'application/pdf',
            'Content-Type': 'application/pdf',
            Authorization: `Bearer ${getToken()}`,
          },
        }
      );
      if (result.status >= 200 && result.status < 300) {
        notify(translate('resources.invoices.pdf_success'));

        const blob = await result.blob();
        window.open(URL.createObjectURL(blob));
      } else {
        notify(translate('resources.invoices.pdf_error'));
      }
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
    } catch (e: any) {
      console.warn(e);

      notify(e.message ?? JSON.stringify(e));
    }
  };
  return record ? (
    <Button
      onClick={() => getInvoicePdf(record[props.source])}
      startIcon={<PictureAsPdfIcon />}
      aria-label={translate('resources.invoices.pdf')}
    >
      {translate('resources.invoices.name', { smart_count: 1 })}
    </Button>
  ) : null;
};

export default InvoicePdfButton;
